module.exports = __webpack_public_path__ + "img/diy.05643971.svg";